var Chart = require('chart.js');

mySynch.controller('CohortDetailController', [
	'$scope',
	'MySynchFactory',
	'ApiFactory',
	'FertilityFactory',
	'ViewAuthorizationFactory',
	'clientLoggerService',
	function CohortDetailController($s, MSF, api, fertility,viewAuth, log) {
		if (!MSF.state.params.cohort || !MSF.state.params.rha) {
			return loadFertilityDashboard();
		}

		var cohort = MSF.state.params.cohort;
		var rha = MSF.state.params.rha;

		var barColors = [
			_.find(MSF.colorComponents, {color: 'red'}),
			_.find(MSF.colorComponents, {color: 'green'}),
			_.find(MSF.colorComponents, {color: 'orange'})
		];

		var moreBarColors = barColors.concat(_.find(MSF.colorComponents, {color: 'purple'}));

		var barChartOptions = {
			legend: {
				display: false
			},
			scales: {
				yAxes: [{
					gridLines: {
						display: false
					},
					ticks: {
						beginAtZero: true,
						stepSize: 10,
						max: 150,
						display: false
					}
				}],
				xAxes: [{
					gridLines: {
						display: false
					}
				}]
			},
			tooltips: {
				enabled: false
			},
			animation: {
				onProgress: renderLabelsForChart,
				onComplete: renderLabelsForChart
			}
		};

		var pregnantChart;
		var inseminationChart;
		var conceptionChart;

		var updatedDate = moment(cohort.reportDate);
		var startDate = moment(cohort.startDate);
		var endDate = moment(cohort.endDate);

		var startFormat = 'MMM. DD';
		var endFormat = 'DD, YYYY';

		if (!startDate.isSame(endDate, 'year')) {
			startFormat += startDate.format(', YYYY');
		}

		if (!startDate.isSame(endDate, 'month')) {
			endFormat = 'MMM. ' + endFormat;
		}

		var today = moment().startOf('week').add(1, 'day').subtract(moment().utcOffset(), 'minutes');
		var daysInMilk = Math.floor(moment.duration(today.diff(moment(cohort.endDate))).as('days')) + '-' +
							Math.floor(moment.duration(today.diff(moment(cohort.startDate))).as('days'));
		$s.loading = true;
		$s.showError = false;
		$s.showNoData = false;
		$s.cohortTitle = 'Cohort ' + startDate.format(startFormat) + '–' + endDate.format(endFormat) + ' (' + daysInMilk + ' DIM)';
		$s.dataUpdatedDate; //= moment(updatedDate).format(MSF.i18n.format.dateLong);

		$s.rhaBoxItems = {
			CF: {
				freshened: cohort.count,
				daysInMilk: moment(updatedDate).diff(startDate, 'days')
			},
			IR: {
				cohort: cohort.inseminationRate,
				rha: rha.IR
			},
			CR: {
				cohort: cohort.conceptionRate,
				rha: rha.CR
			},
			PR: {
				cohort: cohort.pregnancyRate,
				rha: rha.PR
			}
		};

		$s.chartBoxItems = {
			pregnant: {
				notPregnant: -1,
				pregnantTai: -1,
				pregnantBredToHeat: -1

			},
			IR: {
				tai: -1,
				bredToHeat: -1
			},
			CR: {
				tai: -1,
				bredToHeat: -1
			}
		};

		$s.dnbDiedOrSold = -1;
		$s.dataExceptions = -1;

		$s.pageViewBetaReq = ["CohortDash_Old"];

		$s.checkPermissions = function checkPermissions(){
			if(!viewAuth.farmIsInBeta($s.pageViewBetaReq)){   
				 var homePageStateName =  MSF.getUserHomepageStateName();
				 MSF.loadPage(homePageStateName);
			}

		}

		function loadFertilityDashboard() {
			MSF.loadPage('FertilityDashboard');
		}

		function renderLabelsForChart() {
			var self = this;
			var ctx = self.chart.ctx;
			ctx.fillStyle = '#000000';
			ctx.textAlign = 'center';
			ctx.textBaseline = 'bottom';

			var fontSize = 26;
			var fontStyle = 'normal';
			var fontFamily = '"Helvetica Neue", Helvetica, Arial, sans-serif';
			ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);

			self.data.datasets.forEach(function renderLabelsForDataset(dataset, i) {
				var meta = self.getDatasetMeta(i);

				if (!meta.hidden) {
					meta.data.forEach(function renderLabelForBar(element, index) {
						var dataString = dataset.data[index].toString() + '%';
						var position = element.tooltipPosition();

						ctx.fillText(dataString, position.x, position.y - 5);
					});
				}
			});
		}

		function renderLabelsForPieChart() {
			var self = this;
			var ctx = self.chart.ctx;
			ctx.fillStyle = '#000000';
			ctx.textAlign = 'center';
			ctx.textBaseline = 'bottom';

			var fontSize = 14;
			var fontStyle = 'normal';
			var fontFamily = '"Helvetica Neue", Helvetica, Arial, sans-serif';
			ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);

			self.data.datasets.forEach(function renderLabelsForDataset(dataset, i) {
				var meta = self.getDatasetMeta(i);

				if (!meta.hidden) {
					meta.data.forEach(function renderLabelForBar(element, index) {
						if (dataset.data[index] <= 0) {
							// don't show
							return;
						}

						var labelLine1 = self.data.labels[index];
						var labelLine2;
						var splitLocation = labelLine1.indexOf(' (');

						if (splitLocation > -1) {
							labelLine2 = labelLine1.substr(splitLocation + 1);
							labelLine1 = labelLine1.substr(0, splitLocation);
						}

						var dataString = dataset.data[index].toString();
						var position = element.tooltipPosition();
						var lineY = position.y - fontSize;

						ctx.fillText(labelLine1, position.x, lineY);
						lineY += fontSize + 2;

						if (labelLine2) {
							ctx.fillText(labelLine2, position.x, lineY);
							lineY += fontSize + 2;
						}

						ctx.fillText(dataString, position.x, lineY);
					});
				}
			});
		}

		function loadCohortDetails() {
			$s.loading = true;
			$s.showError = false;
			$s.showNoData = false;

			var herdId = _.get(cohort, 'herdId');
			var breedingWeek = _.get(cohort, 'breedingWeekRaw');

			api.getCohortDetails(herdId, breedingWeek, function gotDetails(err, details) {
				if (err) {
					log.error({error: err, herdId: herdId, breedingWeek: breedingWeek}, 'unable to load cohort details');
					$s.showError = true;
					$s.loading = false;

					return;
				}

				if (_.isEmpty(details)) {
					log.warn({herdId: herdId, breedingWeek: breedingWeek}, 'no results for getCohortDetails');
					$s.showNoData = true;
					$s.loading = false;

					return;
				}

				$s.loading = false;
				updateCharts(details[0]);
			});
		}

		function updateCharts(cohortDetails) {
			// format for display
			$s.chartBoxItems = {
				pregnant: {
					notPregnant: cohortDetails.notPregnant,
					pregnantTai: cohortDetails.pregnantTai,
					pregnantBredToHeat: cohortDetails.pregnantHdai

				},
				IR: {
					tai: _.round(cohortDetails.inseminationRateTai * 100, 1),
					bredToHeat: _.round(cohortDetails.inseminationRateHdai * 100, 1)
				},
				CR: {
					tai: _.round(cohortDetails.conceptionRateTai * 100, 1),
					bredToHeat: _.round(cohortDetails.conceptionRateHdai * 100, 1)
				}
			};

			$s.byService = {
				first: {
					tai: {
						conceptionRate: _.round(cohortDetails.firstServiceConceptionRateTai * 100, 1),
						inseminationRate: _.round(cohortDetails.firstServiceInseminationRateTai * 100, 1),
						cowsServiced: cohortDetails.firstServiceCowsServicedTai,
						pregnancyCount: cohortDetails.firstServicePregnancyCountTai
					},
					hdai: {
						conceptionRate: _.round(cohortDetails.firstServiceConceptionRateHdai * 100, 1),
						inseminationRate: _.round(cohortDetails.firstServiceInseminationRateHdai * 100, 1),
						cowsServiced: cohortDetails.firstServiceCowsServicedHdai,
						pregnancyCount: cohortDetails.firstServicePregnancyCountHdai
					}
				},
				second: {
					tai: {
						conceptionRate: _.round(cohortDetails.secondServiceConceptionRateTai * 100, 1),
						inseminationRate: _.round(cohortDetails.secondServiceInseminationRateTai * 100, 1),
						cowsServiced: cohortDetails.secondServiceCowsServicedTai,
						pregnancyCount: cohortDetails.secondServicePregnancyCountTai
					},
					hdai: {
						conceptionRate: _.round(cohortDetails.secondServiceConceptionRateHdai * 100, 1),
						inseminationRate: _.round(cohortDetails.secondServiceInseminationRateHdai * 100, 1),
						cowsServiced: cohortDetails.secondServiceCowsServicedHdai,
						pregnancyCount: cohortDetails.secondServicePregnancyCountHdai
					}
				},
				third: {
					tai: {
						conceptionRate: _.round(cohortDetails.thirdServiceConceptionRateTai * 100, 1),
						inseminationRate: _.round(cohortDetails.thirdServiceInseminationRateTai * 100, 1),
						cowsServiced: cohortDetails.thirdServiceCowsServicedTai,
						pregnancyCount: cohortDetails.thirdServicePregnancyCountTai
					},
					hdai: {
						conceptionRate: _.round(cohortDetails.thirdServiceConceptionRateHdai * 100, 1),
						inseminationRate: _.round(cohortDetails.thirdServiceInseminationRateHdai * 100, 1),
						cowsServiced: cohortDetails.thirdServiceCowsServicedHdai,
						pregnancyCount: cohortDetails.thirdServicePregnancyCountHdai
					}
				}
			};

			// dont forget these little guys
			$s.dnbDiedOrSold = cohortDetails.dnbDiedOrSold;
			$s.dataExceptions = cohortDetails.dataExceptions;

			var fills = _.map(moreBarColors, 'fillColor');
			var strokes = _.map(moreBarColors, 'strokeColor');

			var pieValues = _([
				{label: 'Not Pregnant',				value: cohortDetails.notPregnant - cohortDetails.dnbDiedOrSold,	fill: fills[0], stroke: strokes[0]},
				{label: 'Pregnant (TAI)',			value: cohortDetails.pregnantTai,								fill: fills[1], stroke: strokes[1]},
				{label: 'Pregnant (Bred to Heat)',	value: cohortDetails.pregnantHdai,								fill: fills[2], stroke: strokes[2]},
				{label: 'DNB, Died or Sold',		value: cohortDetails.dnbDiedOrSold,								fill: fills[3], stroke: strokes[3]}
			]).sortByOrder('value', 'DESC').reject({value: 0}).value();

			// pregant chart
			if (pregnantChart) {
				pregnantChart.destroy();
			}

			var pregnantChartElement = $('#pregnant-chart')[0];

			if (!pregnantChartElement) {
				log.warn('NO CHART ELEMENT!');
			} else {
				pregnantChart = new Chart(pregnantChartElement, {
					type: 'pie',
					data: {
						labels: _(pieValues).map('label').value(),
						datasets: [{
							data: _(pieValues).map('value').value(),
							backgroundColor: _(pieValues).map('fill').value(),
							borderColor: _(pieValues).map('stroke').value()
						}]
					},
					options: _.extend(_.omit(barChartOptions, 'scales'), {
						animation: {
							onProgress: renderLabelsForPieChart,
							onComplete: renderLabelsForPieChart
						}
					})
				});
			}

			// insemination rate chart
			if (inseminationChart) {
				inseminationChart.destroy();
			}

			var inseminationChartElement = $('#insemination-chart')[0];

			if (!inseminationChartElement) {
				log.warn('NO CHART ELEMENT!');
			} else {
				inseminationChart = new Chart(inseminationChartElement, {
					type: 'bar',
					data: {
						labels: ['TAI', 'Bred to Heat'],
						datasets: [{
							data: [
								_.round(cohortDetails.inseminationRateTai * 100, 1),
								_.round(cohortDetails.inseminationRateHdai * 100, 1)
							],
							backgroundColor: _.map(barColors.slice(1), 'fillColor'),
							borderColor: _.map(barColors.slice(1), 'strokeColor')
						}]
					},
					options: barChartOptions
				});
			}

			// conception rate chart
			if (conceptionChart) {
				conceptionChart.destroy();
			}

			var conceptionChartElement = $('#conception-chart')[0];

			if (!conceptionChartElement) {
				log.warn('NO CHART ELEMENT!');
			} else {
				conceptionChart = new Chart(conceptionChartElement, {
					type: 'bar',
					data: {
						labels: ['TAI', 'Bred to Heat'],
						datasets: [{
							data: [
								_.round(cohortDetails.conceptionRateTai * 100, 1),
								_.round(cohortDetails.conceptionRateHdai * 100, 1)
							],
							backgroundColor: _.map(barColors.slice(1), 'fillColor'),
							borderColor: _.map(barColors.slice(1), 'strokeColor')
						}]
					},
					options: barChartOptions
				});
			}
		}

		$s.fertilityPerformanceClicked = loadFertilityDashboard;

		$s.$on('herd:changed', function herdChanged(){
			$s.checkPermissions();
			
			var currentActiveHerdId = _.get(MSF.getActiveHerd(), 'herdId');
			var currentActiveHerdAdditionalHerdData = MSF.getAdditionalHerdDataItem(currentActiveHerdId);
			var metaLastEventDateString = _.get(currentActiveHerdAdditionalHerdData, 'dataCurrency.metaLastEventDate');
			$s.dataUpdatedDate = !_.isUndefined(metaLastEventDateString) ? moment(metaLastEventDateString).format(MSF.i18n.format.dateLong) : '';
			loadFertilityDashboard();
		}); 

		MSF.ready(function onMsfReady() { 
			$s.checkPermissions();
			
			var currentActiveHerdId = _.get(MSF.getActiveHerd(), 'herdId');
			var currentActiveHerdAdditionalHerdData = MSF.getAdditionalHerdDataItem(currentActiveHerdId);
			var metaLastEventDateString = _.get(currentActiveHerdAdditionalHerdData, 'dataCurrency.metaLastEventDate');
			$s.dataUpdatedDate = !_.isUndefined(metaLastEventDateString) ? moment(metaLastEventDateString).format(MSF.i18n.format.dateLong) : '';

			loadCohortDetails();
		});
	
	}
]);
